<template>
	<div class="page">
		<!-- your page -->
		<div class="order">
			<div class="topNav">
				<div class="item" v-for="item in nav" :data-id="item.id" :id="item.select" @click="change">
					{{item.name}}
				</div>
			</div>
			<div class="table">
				<div class="tHead">
					<div class="product">
						商品
					</div>
					<div class="unitPrice">
						单价
					</div>
					<div class="number">
						数量
					</div>
					<div class="pay" v-show="this.status!=6">
						实付
					</div>
					<div class="pay" v-show="this.status==6">
						退款
					</div>
					<div class="status">
						交易状态
					</div>
					<div class="operation">
						操作
					</div>
				</div>
				<div class="tBody">
					<div class="block" v-for="(item,index) in list" :key="index">
						<div class="blockTitle">
							<div class="orderNumber" v-show="item.code!=11&&item.code!=12&&item.code!=13">
								订单号:{{item.order_id}}
							</div>
							<div class="orderNumber" v-show="item.code==11||item.code==12||item.code==13">
								售后单号:{{item.order_id}}
							</div>
							<div class="delBtn" v-show="false">
								<i class="el-icon-delete"></i>
							</div>
						</div>
						<div class="unit">
							<div class="left">
								<div class="unitBox" v-for="(tab,tabIndex) in item.items" :key="tabIndex">
									<div class="avatar">
										<img :src="tab.image_url" alt="">
									</div>
									<div class="info">
										<div class="name">
											{{tab.name}}
										</div>
										<div class="specification">
											{{tab.specification}}
										</div>
									</div>
									<div class="unitPrice">
										{{tab.amount}}
									</div>
									<div class="number">
										{{tab.nums}}
									</div>
								</div>
							</div>
							<div class="right" :style="'height:'+item.items.length*90+'px'">
								<div class="rightPay">
									<div class="payIn">
										¥{{item.order_amount}}
									</div>
								</div>
								<div class="rightStatus">
									<div class="statusIn">
										<div class="statusWord">
											{{item.status}}
										</div>
										<div class="detail" @click="goDetail" :data-id="item.order_id" :data-status="item.code">
											订单详情
										</div>
									</div>
								</div>
								<div class="rightOperation">
									<div class="operationBox">
										<div class="goPay" v-if="item.code==1" :data-amount="item.order_amount" :data-oid="item.order_id" @click="goPay">
											去付款
										</div>
										<div class="confirm" v-if="item.code==3" :data-oid="item.order_id" @click="confirm">
											确认收货
										</div>
										<div class="goEva" v-if="item.code==4" :data-oid="item.order_id" @click="goEva">
											去评价
										</div>
										<div class="cancel" v-if="item.code==1" :data-oid="item.order_id" @click="cancel(item.order_id)">
											取消订单
										</div>
										<div class="refund" v-if="item.code==2||item.code==3" :data-oid="item.order_id" @click="refund">
											申请退款
										</div>
										<div class="refund" v-if="item.code==4" :data-oid="item.order_id" @click="refund">
											申请退货
										</div>
										<div class="afterSell" v-if="item.code==5" :data-oid="item.order_id" @click="refund">
											申请售后
										</div>
									</div>
								</div>
							</div>
							<div class="clear"></div>
						</div>
					</div>
				</div>
				<div class="pager">
					<el-pagination background layout="prev, pager, next" :page-size="limit" :current-page="page" :total="totalPage*limit" @current-change="clickPage" @prev-click="prevPage" @next-click="nextPage"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'default',
		data(){
			return {
				nav:[
					{"id":"0","select":"select","name":"全部订单"},
					{"id":"1","select":"","name":"待付款"},
					{"id":"2","select":"","name":"待发货"},
					{"id":"3","select":"","name":"待收货"},
					{"id":"4","select":"","name":"待评价"},
					{"id":"6","select":"","name":"售后"}
				],
				list:[],
				page:1,
				limit:10,
				status:0,
				totalPage:1,
			}
		},
		inject:['tabRouter'],
		methods:{
			clickPage(page){
				this.page = page
				var sid = this.status
				this.query(sid)
			},
			prevPage(e){
				this.page = e
			},
			nextPage(e){
				this.page = e
			},
			query(sid){
				this.status = sid
				if(sid!=6){
					this.fetchData()
				}else{
					this.getAfterSale()
				}
			},
			change(e){
				var id = e.target.dataset.id
				this.tabRouter(e)
			},
			navChange(id){
				this.page=1
				this.status = id
				var nav = this.nav
				for (var i = 0; i < nav.length; i++) {
					var nid = nav[i].id
					nav[i].select=""
					if(id==nid){
						nav[i].select = "select"
					}
				}
				this.$router.push({path:'/person/order',query:{mid:id}})
				this.nav = nav
				this.query(id)
			},
			getAfterSale(){
				var data = {
					page: this.page,
					limit: this.limit,
					token: this.token,
					method: "order.aftersaleslist"
				}
				var that = this
				this.list = []
				this.request(data,function(res){
					if(res.status){
						var relist = res.data.list
						for (var i = 0; i < relist.length; i++) {
							var item = relist[i]
							var this_status,this_status_code
							if(item.status==1){
								this_status="审核中"
								this_status_code = 11
							}else if(item.status==2){
								this_status="已通过"
								this_status_code = 12
							}else{
								this_status="未通过"
								this_status_code = 13
							}
							var obj = {
								orderNumber:item.aftersales_id,
								tab:item.order.items,
								price:item.refund,
								status:this_status,
								code:this_status_code
							}
							that.list.push(obj)
						}
					}else{
						that.globalTest('order.aftersaleslist','error',res.msg,res.data)
					}
				})
			},
			goPay(e){
				var amount = e.target.dataset.amount
				var oid = e.target.dataset.oid
				this.$router.push({path:'/pay',query:{order_id:oid,type:'commodity','free':amount}})
			},
			confirm(e){
				var oid = e.target.dataset.oid
				var data = {
					order_id:oid,
					token:this.token,
					method:"order.confirm"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('order.confirm','success','确认收货成功')
					}else{
						that.globalTest('order.confirm','error',res.msg,res.data)
					}
				})
			},
			cancel(id){
				console.log(id);
				var oid = id
				var data = {
					order_ids:oid,
					token:this.token,
					method:"order.cancel"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('order.cancel','success','取消订单成功')
						that.fetchData()
					}else{
						that.globalTest('order.cancel','error',res.msg,res.data)
					}
				})
			},
			refund(e){
				var id = e.target.dataset.oid
				this.$router.push({path:'/refund',query:{oid:id}})
			},
			goEva(e){
				var id = e.target.dataset.oid
				this.$router.push({path:'/evaluate',query:{oid:id}})
			},
			goDetail(e){
				var id = e.target.dataset.id
				var status = e.target.dataset.status
				this.$router.push({path:'/detail',query:{oid:id,status:status}})
			},
			fetchData(){
				var data = {
					page: this.page,
					limit: this.limit,
					status: this.status,
					token: this.token,
					method: "order.getorderlist",
				}
				var that = this
				// that.list = []
				this.request(data,function(res){
					if(res.status){
						that.totalPage = res.data.max_page
						// var reList = res.data.list
						that.list = res.data.list
						console.log(that.list,'that.list');
						for (let i in that.list) {
							var item = that.list[i]
							var pay_status = item.pay_status
							var ship_status = item.ship_status
							var status = item.status
							var is_comment = item.is_comment
							var confirm = item.confirm
							// var this_status
							// var this_status_code
							
							if(status==1){
								//正常订单
								if(confirm==1){
									//没有确认收货的
									if(pay_status==1){
										//未付款的
										that.list[i].status = '未付款'
										that.list[i].code = 1
									}else if(pay_status==2){
										//已付款的
										if(ship_status==1){
											that.list[i].status = '待发货'
											that.list[i].code = 2
										}else if(ship_status==3){
											that.list[i].status = '待收货'
											that.list[i].code = 3
										}
									}
								}else if(confirm==2){
									//已经确认收货的
									if(is_comment==1){
										//没有评价过的
										that.list[i].status = '待评价'
										that.list[i].code = 4
									}else if(is_comment==2){
										//已经评价过的
										that.list[i].status = '已评价'
										that.list[i].code = 5
									}
								}
							}else if(status==2){
								//已完成订单
								if(pay_status==5){
									that.list[i].status = '已退款'
									that.list[i].code = 6
								}
							}else if(status==3){
								//取消订单
								that.list[i].status = "已取消"
								that.list[i].code = 7
							}
							// var obj = {
							// 	orderNumber:item.order_id,
							// 	tab:item.items,
							// 	price:item.order_amount,
							// 	status:this_status,
							// 	code:this_status_code
							// }
							// that.list.push(obj)
						}
					}else{
						that.globalTest('order.getorderlist','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.order{
		width: 100%;
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.topNav{
		width: 100%;
		height: 60px;
	}
	.topNav .item{
		width: 153px;
		height: 50px;
		float: left;
		margin-top: 10px;
		text-align: center;
		line-height: 50px;
		border-bottom: 2px solid #C3C3C3;
		box-sizing: border-box;
		cursor: pointer;
	}
	.topNav .item:hover{
		background: #F0F0F0;
	}
	.topNav #select{
		border-bottom: 2px solid #036DEE;
		box-sizing: border-box;
	}
	.table{
		width: 100%;
		margin-top: 10px;
		padding-bottom: 20px;
	}
	.tHead{
		width: 100%;
		height: 40px;
		background: #F0F0F0;
	}
	.product,.unitPrice,.number,.pay,.status,.operation{
		height: 100%;
		float: left;
		text-align: center;
		line-height: 40px;
	}
	.product{
		width: 360px;
	}
	.unitPrice{
		width: 100px;
	}
	.number{
		width: 100px;
	}
	.pay{
		width: 120px;
	}
	.status{
		width: 120px;
	}
	.operation{
		width: 120px;
	}
	.tBody{
		width: 100%;
	}
	.block{
		width: 100%;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
		margin-top: 10px;
	}
	.blockTitle{
		width: 100%;
		height: 40px;
		line-height: 40px;
		background: #F0F0F0;
	}
	.orderNumber{
		width: 858px;
		height: 100%;
		float: left;
		padding-left: 10px;
		box-sizing: border-box;
	}
	.delBtn{
		width: 100px;
		height: 100%;
		float: left;
		text-align: right;
		padding-right: 10px;
		box-sizing: border-box;
	}
	.unit{
		width: 100%;
		min-height: 90px;
	}
	.left{
		width: 559px;
		height: 100%;
		float: left;
	}
	.unitBox{
		width: 100%;
		height: 90px;
	}
	.unitBox .avatar{
		width: 90px;
		height: 100%;
		float: left;
	}
	.unitBox .avatar img{
		width: 80px;
		height: 80px;
		display: block;
		margin: 5px auto;
	}
	.unitBox .info{
		width: 269px;
		height: 100%;
		float: left;
	}
	.name{
		width: 100%;
		height: 50px;
		line-height: 25px;
		overflow: hidden;
		font-size: 12px;
	}
	.specification{
		width: 100%;
		height: 40px;
		line-height: 40px;
		color: #838383;
		font-size: 12px;
	}
	.unitBox .unitPrice,.unitBox .number{
		line-height: 90px;
	}
	.unitBox .unitPrice{
		color: red;
	}
	.right{
		width: 359px;
		float: left;
	}
	.right .rightPay{
		width: 119px;
	}
	.right .rightStatus{
		width: 119px;
	}
	.right .rightOperation{
		width: 120px;
	}
	.right .rightPay,.right .rightStatus,.right .rightOperation{
		height: 100%;
		float: left;
		position: relative;
	}
	.operationBox{
		width: 100%;
		min-height: 60px;
		position: absolute;
		left: 0px;
		top: 50%;
		margin-top: -30px;
		text-align: center;
		line-height: 30px;
	}
	.goPay:hover,.confirm:hover,.goEva:hover{
		color: #036DEE;
		cursor: pointer;
	}
	.cancel:hover,.refund:hover,.afterSell:hover{
		color: #FF0000;
		cursor: pointer;
	}
	.payIn{
		width: 100%;
		height: 50px;
		position: absolute;
		left: 0px;
		top: 50%;
		margin-top: -25px;
		line-height: 50px;
		text-align: center;
		color: red;
	}
	.statusIn{
		width: 100%;
		height: 60px;
		position: absolute;
		left: 0px;
		top: 50%;
		margin-top: -30px;
		text-align: center;
		line-height: 30px;
	}
	.statusWord,.detail{
		width: 100%;
		height: 30px;
	}
	.detail:hover{
		color: #036DEE;
		cursor: pointer;
	}
	.clear{
		clear: both;
	}
	.pager{
		width: 100%;
		height: 50px;
		margin-top: 30px;
	}
</style>
